export const reportColors = {
    clients: { text: "text-brand-700", bar: "bg-brand-600" },
    moved: { text: "text-emerald-700", bar: "bg-emerald-600" },
    active: { text: "text-gray-500", bar: "bg-gray-400" },
    closed: { text: "text-amber-700", bar: "bg-amber-500" },
    invoiced: { text: "text-teal-700", bar: "bg-teal-600" },
    avgPerMove: { text: "text-cyan-700", bar: "bg-cyan-600" },
    overdue: { text: "text-red-700" },
    upcoming: {
        text: "text-brand-700",
        bar: "bg-brand-500",
        badge: "bg-emerald-100 text-emerald-700",
    },
    newUnsent: { text: "text-amber-700" },
    cashFlowBar: "bg-brand-500",
    categoryDot: "bg-brand-500",
    viewModeActive: "bg-brand-600",
};
